import { Session } from 'src/app/types';
import { props } from '@ngrx/store';
import { createAction } from '@ngrx/store';


// This actions will called to create action and load the data in store

// command
export const loadSessionCount=createAction(
    "[SessionCount Init] Load Session Count"
)

// effect action
export const sessionCountLoaded = createAction(
    "[Load Session Count Effect] Session Count Loaded",
    props<{sessionCount:Session.SessionCountResponse}>()
);
